export enum Country {
    UNDEFINED = '',
    GHANA = 'GH',
    ZAMBIA = 'ZM',
    KENYA = 'KE',
    NIGERIA = 'NG',
}
